'use client'

import { useContext } from 'react'
import { AuthContext } from '../../modules/auth/authContext'
import Script from 'next/script'

export const PendoInit: React.FC = () => {
    const { user, client } = useContext(AuthContext)

    return !user || !client || !process.env.NEXT_PUBLIC_PENDO_API_KEY ? null : (
        <Script
            id="pendo-script"
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
                __html: `
          (function(apiKey){
            (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
            v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
              o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
              y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
              z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
            pendo.initialize({
              visitor: {
                id: '${user.id}',
                email: '${user.username}',
                firstName: '${user.name}',
                lastName: '',
              },
              account: {
                id: '${client.clientHash}',
                accountName: '${client.name}',
                payingStatus: 'paying',
              }
            });
          })('${process.env.NEXT_PUBLIC_PENDO_API_KEY}');
        `,
            }}
        />
    )
}
